import React from "react";
import { Typography, IconButton, Checkbox, FormControlLabel } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import LockIcon from "@mui/icons-material/Lock";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useDispatch, useSelector } from "react-redux";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { Redirect } from "react-router";
import styles from "./login.module.scss";
import TextField from "../../../common/form-control/form-control";
import { RootState } from "../../../../store";
import { routes } from "../../../../constants";
import borderStyles from "./login-stlyes";
import { clientPortalLogin } from "../../../common/services/api/authentication";
import { saveAuthData } from "../../../../auth/authentication";
import { setIsClientPortalUserAuthenticated } from "../../../../slices/clientPortalAuthSlice";
import { Messages } from "../../../../helpers/messages";
import Notifications from "../../../../containers/FlashMessage/Notification";
import { getAccountDetails } from "../../../../slices/clientPortalUserInfoSlice";
import dispatchNotification from "../../../common/actions/dispatchNotification";

/**
 * @todo: Fetch resourcecenter data
 */
const resourceCenter = {
  logoUrl: "https://okhati-test.s3.ap-south-1.amazonaws.com/1730112562007_blob",
  name: "Samaj Dental"
};

const ClientPortalLogin = (): React.JSX.Element => {
  const [email, setEmail] = React.useState<string>("");
  const [password, setPassword] = React.useState<string>("");
  const [showPassword, setShowPassword] = React.useState<boolean>(false);
  const [rememberMe, setRememberMe] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const isClientPortalUserAuthenticated = useSelector(
    (state: RootState) => state.isClientPortalUserAuthenticated
  );
  const { clientPortal } = routes;

  const isMounted = React.useRef(false);

  React.useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const dispatch = useDispatch();
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!isMounted.current) return;
    setIsLoading(true);
    const response = await clientPortalLogin({
      username: email,
      password,
      isClientPortalUser: true
    });
    if (response?.message === "Auth Passed") {
      saveAuthData(response);
      dispatch(setIsClientPortalUserAuthenticated(true));
      dispatchNotification.success(dispatch, Messages.loginSuccess);
      dispatch(getAccountDetails());
      return;
    }
    if (response?.response.status === 401) {
      dispatchNotification.error(
        dispatch,
        response?.response?.data?.map((err) => err.msg).join(" ")
      );
      setIsLoading(false);
      return;
    }
    if (isMounted.current) setIsLoading(false);
  };

  const handleForgetPassword = () => {
    // Implement your forget password logic here
  };

  if (isClientPortalUserAuthenticated) {
    return <Redirect to={`${clientPortal.name}/${clientPortal.subRoutes.dashBoard.name}`} />;
  }

  return (
    <div className={styles.mainContainer}>
      <Notifications />
      <div className={styles.formContainer}>
        <div className={styles.header}>
          <img src={resourceCenter.logoUrl} alt="logo" height="42" width="42" />
          <Typography variant="h6" color="white">
            {resourceCenter.name}
          </Typography>
        </div>
        <Typography variant="h5" color="white">
          Login
        </Typography>
        <form onSubmit={handleLogin}>
          <TextField
            value={email}
            placeholder="Enter your email"
            onChange={({ target }) => setEmail(target.value)}
            startIcon={<MailOutlineIcon className={styles.mailIcon} />}
            autoComplete="email"
            customStyles={borderStyles}
          />
          <TextField
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={password}
            onChange={({ target }) => setPassword(target.value)}
            startIcon={<LockIcon className={styles.lockIcon} />}
            className={styles.password}
            endIcon={
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setShowPassword(!showPassword)}
                edge="end"
                className={styles.visibilityToggle}
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            }
            autoComplete="current-password"
            customStyles={borderStyles}
          />
          <div className={styles.formFooter}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  className={styles.checkbox}
                />
              }
              label="Remember me"
            />
            <Typography className={styles.forgetMe} onClick={() => handleForgetPassword()}>
              Forget Password?
            </Typography>
          </div>
          <LoadingButton
            disabled={isLoading}
            type="submit"
            className={styles.loginButton}
            variant="contained"
            loading={isLoading}
          >
            {isLoading ? "" : "Login"}
          </LoadingButton>
        </form>
      </div>
    </div>
  );
};

export default ClientPortalLogin;
